import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function bulkTransferStories(purchaseId, storyIds, createdBy) {
    const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/purchases/${encodeURIComponent(purchaseId)}/bulk-transfer`,
        { storyIds, createdBy },
        { headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}`,
        } }
    );
    if (String(response.data?.status?.code) !== '10200' || !response.data?.data) {
        const error = new Error(response.data?.status?.message || 'Unable to import stories.');
        error.response = response;
        throw error;
    }
    return response.data.data;
}
